import React from 'react';
import { useLocation } from 'react-router-dom';
import VideoHero from './VideoHero';

const PAGE_HEROES = [
  { match: /^\/package\//, title: 'Goa Tour Packages', subtitle: 'Customised holidays with hotels, transfers, tours & activities' },
  { match: /^\/hotel\//, title: 'Hotels in Goa', subtitle: 'Comfortable stays in and around Calangute' },
  { match: /^\/packages/, title: 'Goa Tour Packages', subtitle: 'Explore all customised Goa holiday packages' },
  { match: /^\/hotels-list|^\/hotels-old|^\/hotels/, title: 'Hotels & Stays', subtitle: 'Find the right stay for your Goa trip' },
  { match: /^\/activities/, title: 'Cruises & Activities', subtitle: 'Dinner cruises, adventure boats, waterfall trips & more' },
  { match: /^\/tours/, title: 'Sightseeing Tours', subtitle: 'North Goa, South Goa and day trips with local coordination' },
  { match: /^\/taxi/, title: 'Private Transfers', subtitle: 'Airport, railway and local transfers across Goa' },
  { match: /^\/homestay/, title: 'Homestays in Goa', subtitle: 'Local stays with a personal touch' },
  { match: /^\/villa/, title: 'Villas in Goa', subtitle: 'Private villas for families and groups' },
  { match: /^\/flights/, title: 'Flights to Goa', subtitle: 'Plan your arrival with GoaDeals' },
  { match: /^\/yatch|^\/yacht/, title: 'Yacht Experiences', subtitle: 'Private cruises and yacht experiences in Goa' },
  { match: /^\/list-property/, title: 'List Your Property', subtitle: 'Partner with GoaDeals and reach more travellers' },
  { match: /^\/my-trip/, title: 'My Trip', subtitle: 'Your Goa trip details in one place' },
  { match: /^\/search/, title: 'Search Goa Stays', subtitle: 'Find hotels and packages for your dates' },
];

const DEFAULT_HERO = {
  title: 'Explore Goa Your Way',
  subtitle: 'Packages, hotels, sightseeing, cruises and activities with local Goa support',
};

const AppVideoHero = () => {
  const { pathname } = useLocation();
  const isHome = pathname === '/' || pathname === '/home';

  if (isHome) return null;

  const page = PAGE_HEROES.find((item) => item.match.test(pathname)) || DEFAULT_HERO;

  return <VideoHero compact title={page.title} subtitle={page.subtitle} />;
};

export default AppVideoHero;
